function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 283.465"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M133.34 76.231l-20.23 20.075 37.929 38.223H-.002v28.347H150.47l-38.572 37.994 20 20.304 73.463-72.363zM230.289 78.072h28.346v99.213h-28.346zM237.6 218.66c2.7.9 5.5 1.2 8.3 1 8.7-.5 15.5-5.9 16.2-16.2.5-7.2-2.4-13.6-7.8-16.8-3-1.7-6.4-2.5-9.8-2.4h-1.3c-4.7.2-9.1 1.6-12.4 5.5-3.7 4.4-4.5 9.7-3.8 15.4.9 6.9 4.6 11.3 10.6 13.5z"
})));